$( document ).on('turbolinks:load', common_events)

function common_events(){
    function filePreview(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
                $('#image-avatar').html('<img src="'+e.target.result+'" width="186" height="186" class="profile-image" />');
            }
            reader.readAsDataURL(input.files[0]);
        }
    }

    $("#user_profile_picture").on('change', function () {
        filePreview(this);
    });

    $('body').on('shown.bs.modal', '#modal-user', function() {
        $('.js-basic-single').select2({
            dropdownParent: $('#modal-user')
        });
    });

    $('#user_phone').mask('(+000) 000000000');

    // Intercept user form submission to check for existing client
    $('body').on('submit', '#modal-user form', function(e) {
        var $form = $(this);
        var action = $form.attr('action') || '';
        var isUsersForm = action.indexOf('/users') !== -1 || action === '/users';
        var isNewUser = $form.attr('method').toLowerCase() === 'post' && !$form.find('input[name="_method"]').length;
        var skipCheck = $form.data('skip-check');

        // Only check for new user creation (not edit) on users form
        if (isUsersForm && isNewUser && !skipCheck) {
            e.preventDefault();
            e.stopPropagation();

            var email = $form.find('#user_email').val();
            if (!email) {
                // Submit form via AJAX to maintain remote: true behavior
                submitFormViaAjax($form);
                return;
            }

            $('.loader').fadeIn(100);

            $.ajax({
                url: '/users/check_existing_client',
                type: 'POST',
                dataType: 'script',
                data: { email: email },
                error: function() {
                    $('.loader').fadeOut(500);
                    // If check fails, proceed with normal submission
                    submitFormViaAjax($form);
                }
            });
        }
    });

    function submitFormViaAjax($form) {
        var formData = new FormData($form[0]);
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: formData,
            dataType: 'script',
            processData: false,
            contentType: false
        });
    }
}